import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "p-expiration-item-panel" }
const _hoisted_2 = { class: "p-expiration-item-panel__body" }
const _hoisted_3 = { class: "p-expiration-item-panel__date" }
const _hoisted_4 = { class: "p-expiration-item-panel__heading" }
const _hoisted_5 = { "data-translate-skip": "" }
const _hoisted_6 = { class: "p-expiration-item-panel__status" }
const _hoisted_7 = {
  key: 0,
  class: "p-h01-point-confirm-item__text"
}
const _hoisted_8 = { class: "p-expiration-item-panel__type" }
const _hoisted_9 = { class: "p-h01-point-confirm-item__status__label" }
const _hoisted_10 = { class: "p-expiration-item-panel__point" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextLabel = _resolveComponent("TextLabel")!
  const _component_PointNotation = _resolveComponent("PointNotation")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", null, _toDisplayString(_ctx.formated_date), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.detail), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      (_ctx.status)
        ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.status), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        (_ctx.label)
          ? (_openBlock(), _createBlock(_component_TextLabel, {
              key: 0,
              color: { border: _ctx.customizeColor, content: '#ffffff' },
              reverse: false
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.label), 1)
              ]),
              _: 1
            }, 8, ["color"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(_component_PointNotation, {
        "icon-size": false,
        point: _ctx.point,
        point_name: _ctx.point_name,
        "sign-is-exists": false,
        "font-size": 24
      }, null, 8, ["point", "point_name"])
    ])
  ]))
}